import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { useHistory } from "react-router";

import Button from "../Button/Button";
import * as PathUtils from "../../Utils/PathUtils";
import * as SearchConstant from "../../Constants/SearchConstant";

import LogService from "../../../middleware/CommonSdk/LogService";
import PropTypes from "prop-types";

const LOG_TAG = "CARD_TABS";

const TabHeadlinePrefix = "TabHeadline_";
const TabContentPrefix = "TabContent_";

const CardTabs = (props) => {
    const intl = useIntl();
    const [tabIndex, setTabIndex] = useState(0);
    const [tabHeadline, setTabHeadline] = useState(null);
    const [tabContent, setTabContent] = useState(null);
    const [displayResultCount, setDisplayResultCount] = useState(props.moreButtonThreshold);
    const history = useHistory();

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect tabItems");
        let index = tabIndex < props.tabItems.length ? tabIndex : 0;
        parseTabHeadline(index);
        parseTabContent(index);
    }, [props.tabItems, tabIndex, displayResultCount]);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect lastTabIndex");

        let index = props.lastTabIndex < props.tabItems.length ? props.lastTabIndex : 0;
        setTabIndex(index);
    }, [props.lastTabIndex]);

    const handleTabHeadlineClick = index => {
        LogService.info(LOG_TAG, "handleTabHeadlineClick", index);
        setTabIndex(index);

        let currentUrl = history.location.pathname + history.location.search;
        let replacedUrl = PathUtils.addOrUpdateQueryParameterToPathString(currentUrl, SearchConstant.SearchTabIndex, index);
        history.replace(replacedUrl);
    };

    const onMore = () => {
        LogService.trace(LOG_TAG, "onMore", displayResultCount);
        setDisplayResultCount(displayResultCount + props.moreButtonThreshold);
    };

    const parseTabHeadline = (index = 0) => {
        LogService.trace(LOG_TAG, "parseTabHeadline");
        const tabTitle = [];

        props.tabItems.map((item, i) => {
            tabTitle.push(
                <li className="nav-item" key={"card" + TabHeadlinePrefix + i}>
                    <a className={"nav-link" + (index === i ? " active" : "")}
                        id={TabHeadlinePrefix + i}
                        data-toggle="tab"
                        href={"#" + TabContentPrefix + i}
                        role="tab"
                        aria-controls={TabContentPrefix + i}
                        aria-selected={index === i}
                        onClick={() => handleTabHeadlineClick(i)}
                    >
                        {item.title}
                    </a>
                </li>
            );
        });

        setTabHeadline(tabTitle);
    };

    const parseTabContent = (index = 0) => {
        LogService.trace(LOG_TAG, "parseTabContent active index:", index);

        //more button
        let showMoreButton = false;
        if (props.enableMoreButton) {
            if (props.tabItems[index]?.content && displayResultCount > 0 && props.tabItems[index].content.length > displayResultCount) {
                showMoreButton = true;
            }
        }

        //content
        let content = props.tabItems[index]?.content ? props.tabItems[index]?.content : null;
        if (props.tabItems[index]?.content instanceof Array && props.tabItems[index].content.length > 0 && displayResultCount > 0) {
            content = props.tabItems[index].content.slice(0, displayResultCount);
        }

        const activeTabContent =
            // fade removed because 2 tabs display when fast switching (bootstrap issue)
            <div className="tab-pane fade active show"
                style={{ display: "grid" }}
                id={TabContentPrefix + index}
                key={TabContentPrefix + index}
                role="tabpanel"
                aria-labelledby={TabHeadlinePrefix + index}
            >
                {content}
                {showMoreButton &&
                    <Button
                        className="btn-blue col-md-12"
                        label={intl.messages.moreButton}
                        onClick={onMore} />
                }
            </div>

        setTabContent(activeTabContent);
    }

    LogService.trace(LOG_TAG, "render");

    return (
        <div className="card-tab">
            <div className="card-header">
                <ul className="nav nav-tabs card-header-tabs" role="tablist" id="searchResultTabTitle">
                    {tabHeadline}
                </ul>
            </div>
            <div className="card-body" id="searchResultTabContent">
                <div className="tab-content ">
                    {tabContent}
                </div>
            </div >
        </div>
    );
}

CardTabs.defaultProps = {
    tabItems: [],
    enableMoreButton: false,
    moreButtonThreshold: 0,
    lastTabIndex: 0
}

CardTabs.propTypes = {
    tabItems: PropTypes.array,
    enableMoreButton: PropTypes.bool,
    moreButtonThreshold: PropTypes.number,
    lastTabIndex: PropTypes.number
};

export default CardTabs;